<template>
  <div class="wrapper-page">
    <div class="card login-card">
      <div class="card-body">
        <h3 class="text-center mt-3 mb-5">重設密碼</h3>
        <!-- <h4 class="text-muted text-center"></h4> -->

        <form class="form-horizontal m-t-20">
          <div class="col-12">
            <div class="form-group">
              <label for="password">新密碼(8~16字元，含大小寫英文及數字)</label>
              <input id="password" type="password" class="form-control" required v-model="pwd">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="confirm">再次輸入新密碼</label>
              <input id="confirm" type="password" class="form-control" required v-model="confirmPwd">
              <span id="confirm-error" class="help-block text-danger" v-if="showError"> 和原先輸入的密碼不符，請重新輸入 </span>
            </div>
          </div>
          <div class="form-group text-center m-t-40">
            <div class="col-12">
              <button class="btn btn-info btn-block btn-lg waves-effect waves-light" type="submit"
                @click="sendBtn">送出</button>
            </div>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { api } from "../../../apis/main.js";
import { IsNullOrEmpty, GetQueryParams, GetQueryString } from '../../../components/helpers.js';
let $ = window.$;
export default {
  name: 'ResetView',
  props: {
  },
  components: {
  },
  data() {
    return {
      pwd: '',
      confirmPwd: '',
      token: '',
      showError: false
    }
  },
  mounted() {
    localStorage.clear();
    let obj = GetQueryParams(window.location.href);
    if (IsNullOrEmpty(obj.token)) {
      window.location.href = '/login';
    } else {
      this.token = obj.token;
    }
  },
  methods: {
    sendBtn(e) {
      if (this.pwd === this.confirmPwd) {
        this.showError = false;
        let tmp = {
          token: this.token,
          new_password: this.pwd,
          new_password_2: this.confirmPwd
        }
        let qty = GetQueryString(tmp);
        api.post("reset_password", qty).then(res => {
          swal({
            title: '新密碼設定完成',
            text: '請使用新密碼登入',
            type: 'success',
            confirmButtonText: '回登入頁',
            closeOnConfirm: false,
          }, function () {
            window.location.href = '/login';
          })

        }).catch(error => {
          switch (error.response.status) {
            // token找不到或已經失效，導回到登入頁面
            case 404:
              swal({
                title: "Opps!",
                type: "warning",
                html: true,
                text:
                  "<label class='h6'>" +
                  error.response.data.detail +
                  "</label>",
              }, function () {
                window.location.href = '/login';
              });
              break;
            // 2組密碼不符，停在此頁
            case 400:
              swal({
                title: "Opps!",
                type: "warning",
                html: true,
                text:
                  "<label class='h6'>" +
                  error.response.data.detail +
                  "</label>",
              });
              break;
          }
        });
      } else {
        this.showError = true;
      }
      e.preventDefault();
    }

  }
}
</script>

<style scoped>

</style>
